import { IModuleManifest } from 'types';
import routes from './routes';

export const DefaultAppSettingsModule: IModuleManifest = {
    name: 'default-app-settings-module',
    version: '1.0.0',
    description: 'Default AppSettings Module',
    routes,
    menuItems: [{
        id: 'default-app-settings',
        label: 'app:menus.defaultAppSettings',
        iconName: 'ap-settings.solid',
        iconSize: '16',
        order: 200,
        data: {
            route: '/default-app-settings'
        }
    },
    {
        id: 'help',
        label: 'app:menus.help',
        iconName: 'maa-help.solid',
        iconSize: '16',
        order: 300,
        data: {
            route: '/help'
        }
    }
    ]
};
